import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonType, DialogComponent } from '@yupma/ui-kit';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss'
})
export class DeleteDialogComponent {
  @ViewChild(DialogComponent) dialogComponent!: DialogComponent;
  @Output() onClose = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Input() title: string = '';
  buttonTypes = ButtonType;

  closeDialog() {
    this.dialogComponent.closeDialog();
    this.onClose.emit();
  }

  onDeleteClick() {
    this.dialogComponent.closeDialog();
    setTimeout(() => {
      this.onDelete.emit();
    });
  }
}
